import { FormattedMessage } from 'components/shared/Intl';

import { Mode } from '../model';

export interface IPreviewProps {
  canRevert: boolean;
  canvas: HTMLCanvasElement;
  isToolbarHidden?: boolean;
  onModeChanged: (mode: Mode) => void;
  onRevert: () => void;
}

export function Preview(props: IPreviewProps): React.JSX.Element {
  return (
    <>
      {!props.isToolbarHidden && (
        <div className="pb-3">
          <button className="btn btn-discreet-primary me-2" onClick={() => props.onModeChanged(Mode.Drawing)}>
            <FormattedMessage id="lifeRing.editDrawing" />
          </button>
          {props.canRevert && (
            <button className="btn btn-danger" onClick={props.onRevert}>
              <FormattedMessage id="lifeRing.revertDrawing" />
            </button>
          )}
        </div>
      )}
      <div className="shadow">
        <img className="w-100" alt="Screenshot" src={props.canvas.toDataURL('image/png')} />
      </div>
    </>
  );
}
